const {NAMESPACE_MAPPING} = require('@wix/document-services-json-schemas').namespaceMapping
const {dropdownDefaultStyleProperties} = require('./constants')
const {normalizeAlign} = require('../utils')

/** @typedef {import('../types.js').MenuStyleProperties} MenuStyleProperties */
/** @typedef {import('../types.js').MegaMenuContainerItemStyleProperties} MegaMenuContainerItemStyleProperties */

/**
 * @param {Object} pageManager
 * @param {MenuStyleProperties} MenuStyleProperties
 * @param {MegaMenuContainerItemStyleProperties} MegaMenuContainerItemStyleProperties
 * @param {Object} MenuComponent
 */
const migrateMegaMenuContainerItemLayout = (
    pageManager,
    MenuStyleProperties,
    MegaMenuContainerItemStyleProperties,
    MenuComponent
) => {
    const stylableHorizontalMenuProps = pageManager.data.getItem(
        NAMESPACE_MAPPING.props,
        MenuComponent.propertyQuery.replace('#', '')
    )

    const {isContainerStretched} = stylableHorizontalMenuProps

    MegaMenuContainerItemStyleProperties['space-above'] = MenuStyleProperties['submenu---containerMarginTop']
    MegaMenuContainerItemStyleProperties['horizontal-margin'] =
        MenuStyleProperties['mega-menu-container-position-box-margin-left']

    if (isContainerStretched) {
        MegaMenuContainerItemStyleProperties.anchor = 'screen'
        MegaMenuContainerItemStyleProperties.align = 'start'
    } else {
        MegaMenuContainerItemStyleProperties.anchor = 'menuCustomWidth'
        MegaMenuContainerItemStyleProperties.align = normalizeAlign(
            MenuStyleProperties['mega-menu-wrapper-justify-content']
        )
    }

    addDropdownDefaultsIfNeeded(MegaMenuContainerItemStyleProperties)
}

/**
 * @param {MegaMenuContainerItemStyleProperties} styles
 * */
const addDropdownDefaultsIfNeeded = styles => {
    Object.entries(dropdownDefaultStyleProperties).forEach(([key, value]) => {
        if (!styles[key]) {
            styles[key] = value
        }
    })
}

module.exports = {
    migrateMegaMenuContainerItemLayout
}
